import * as React from "react";

import Layout from "../components/layout/layout";
import PrivacyPolicy from "../components/privacy_policies/privacy_policy";
import Seo from "../components/seo";
import { useTranslation } from 'react-i18next';

const PolitiqueDeCookies = () => {
  const {t} = useTranslation();
  return (
    <>
      <Seo
        title={t('privacy_policy')}
        description="Politique De Cookies."
      />
      <Layout>
        <PrivacyPolicy />
      </Layout>
    </>
  )
}

export default PolitiqueDeCookies;
